import React from "react";

export const Preis = (props) => {
  const { preis, kondition, locale, currency, mwst } = props;
  if (!preis || !kondition || !preis[kondition.col]) return null;

  const nr = kondition.col;
  const value = Number(preis[nr]);

  // Netto (Basispreis)
  const netto = Number(value);

  // "Dues" analog Warenkorb-Position: Konditionsänderung als Betrag
  // (kondition.value is a percentage, so: due = netto * pct/100)
  const dues = Number((value / 100) * kondition.value);

  // MwSt: (netto + dues) * mwstPct / 100
  // round (netto + dues) to 2 decimals before VAT calculation
  const mwstPct = !isNaN(mwst) ? Number(mwst) : 0;
  //first rounding, then calculate the brutto, the same as shop-page
  //const nettoPlusDuesRounded = Math.round((netto + dues) * 100) / 100;
  const nettoPlusDuesRounded = netto + dues;
  console.log("netto:", netto, "dues:", dues, "nettoPlusDuesRounded:", nettoPlusDuesRounded, "mwstPct:", mwstPct);
  const mwstBetrag = (nettoPlusDuesRounded * mwstPct) / 100;

  // Brutto: nettoPlusDuesRounded + MwSt
  const brutto = nettoPlusDuesRounded + mwstBetrag;

  const kwert = brutto.toLocaleString(locale || "de-DE", {
    style: "currency",
    currency: currency || "EUR",
  });

  return (
    <div className="d-flex justify-content-end">
      <span>{kwert}</span>
    </div>
  );
};
